import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df3820a6&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=df3820a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3820a6",
  null
  
)

export default component.exports